/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './help.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/router';
import * as i3 from '../../../../app/admin/help/help.component';
import * as i4 from '../../../../app/admin/admin.service';
const styles_HelpComponent:any[] = [i0.styles];
export const RenderType_HelpComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_HelpComponent,data:{}});
export function View_HelpComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,16777216,(null as any),(null as any),1,'router-outlet',
      ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(1,212992,(null as any),0,i2.RouterOutlet,[i2.ChildrenOutletContexts,
          i1.ViewContainerRef,i1.ComponentFactoryResolver,[8,(null as any)],i1.ChangeDetectorRef],
          (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export function View_HelpComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-help',([] as any[]),
      (null as any),(null as any),(null as any),View_HelpComponent_0,RenderType_HelpComponent)),
      i1.ɵdid(1,114688,(null as any),0,i3.HelpComponent,[i4.AdminService],(null as any),
          (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const HelpComponentNgFactory:i1.ComponentFactory<i3.HelpComponent> = i1.ɵccf('app-help',
    i3.HelpComponent,View_HelpComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvaHRtbC9NeURlc2lnblYzL2h0bWwvc3JjL2FwcC9hZG1pbi9oZWxwL2hlbHAuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3Zhci93d3cvaHRtbC9NeURlc2lnblYzL2h0bWwvc3JjL2FwcC9hZG1pbi9oZWxwL2hlbHAuY29tcG9uZW50LnRzIiwibmc6Ly8vdmFyL3d3dy9odG1sL015RGVzaWduVjMvaHRtbC9zcmMvYXBwL2FkbWluL2hlbHAvaGVscC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci93d3cvaHRtbC9NeURlc2lnblYzL2h0bWwvc3JjL2FwcC9hZG1pbi9oZWxwL2hlbHAuY29tcG9uZW50LnRzLkhlbHBDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8cm91dGVyLW91dGxldD48L3JvdXRlci1vdXRsZXQ+IiwiPGFwcC1oZWxwPjwvYXBwLWhlbHA+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTthQUFBOzBEQUFBO1VBQUE7SUFBQTs7OztvQkNBQTtNQUFBO2FBQUE7VUFBQTtJQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/admin/help/help.component.ngfactory.ts